
export default function WhoWeServe() {
  const clients = [
    {
      icon: 'ri-vip-crown-line',
      title: 'Ultra-High-Net-Worth Individuals',
      description: 'Principals requiring absolute medical preparedness and discretion'
    },
    {
      icon: 'ri-building-line',
      title: 'Family Offices & Private Enterprises',
      description: 'Institutional oversight for principal medical security'
    },
    {
      icon: 'ri-plane-line',
      title: 'Private Aviation Operators',
      description: 'Charter fleets and private aircraft requiring medical readiness'
    },
    {
      icon: 'ri-ship-line',
      title: 'Superyachts & Maritime Assets',
      description: 'Luxury maritime operations with embedded medical capability'
    },
    {
      icon: 'ri-home-4-line',
      title: 'High-Value Estates',
      description: 'Private communities requiring comprehensive medical security'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Organizations',
      description: 'Executive medical security for high-exposure operations'
    }
  ];

  return (
    <section id="clientele" className="bg-black py-16 sm:py-24 md:py-32">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16 md:mb-20">
          <div className="text-[8px] sm:text-[9px] uppercase tracking-[0.2em] text-[#606060] font-light mb-3 sm:mb-4">
            Who We Serve
          </div>
          <h2 className="text-[32px] sm:text-[42px] md:text-[56px] font-bold text-[#F0F0F0] leading-tight font-serif">
            Elite Clientele
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {clients.map((client, index) => (
            <div
              key={index}
              className="bg-[#0F0F0F] border border-[#1A1A1A] rounded-2xl p-6 sm:p-8 md:p-10 hover:border-[#2A2A2A] transition-all duration-300"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 flex items-center justify-center mb-4 sm:mb-5 md:mb-6">
                <i className={`${client.icon} text-[32px] sm:text-[40px] md:text-[48px] text-[#F5F5F5]`}></i>
              </div>
              <h3 className="text-base sm:text-lg md:text-[20px] font-semibold text-[#F5F5F5] mb-2 sm:mb-3">
                {client.title}
              </h3>
              <p className="text-xs sm:text-sm md:text-[14px] text-[#A0A0A0] leading-relaxed">
                {client.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
